import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="map"
export default class extends Controller {
  connect() {
    // Wait for Mapkick/Mapbox to initialize
    this.resizeMap()

    // Also resize when the element becomes visible (handles hidden -> visible transitions)
    this.observer = new MutationObserver(() => {
      if (!this.element.classList.contains('hidden')) {
        this.resizeMap()
      }
    })

    this.observer.observe(this.element, {
      attributes: true,
      attributeFilter: ['class']
    })

    // Listen for turbo frame loads (modal content loading)
    document.addEventListener('turbo:frame-load', this.handleFrameLoad)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad)
  }

  handleFrameLoad = () => {
    // Resize map after turbo frame loads new content
    setTimeout(() => this.resizeMap(), 100)
  }

  resizeMap() {
    // Find the Mapbox instance within this controller's element
    const mapContainer = this.element.querySelector('.mapboxgl-map, .mapkickjs')

    if (!mapContainer) return

    // Mapkick stores the map instance on the container element
    const map = mapContainer.map || mapContainer._map

    if (map && typeof map.resize === 'function') {
      // Use requestAnimationFrame to ensure the container has proper dimensions
      requestAnimationFrame(() => {
        map.resize()
      })
    }
  }

  // Action to manually trigger resize (useful for pane switching)
  resize() {
    this.resizeMap()
  }
}
